// Las palabras y colores del estatus y del resultado de un juego, compartidos por la
// tarjeta de la agenda (JuegoCard) y el renglon de la jornada (JuegoFila).
export const ESTATUS_STYLES = {
  programado: 'border-blue-500/30 bg-blue-500/10 text-blue-600',
  en_curso: 'border-green-500/30 bg-green-500/10 text-green-600',
  terminado: 'border-slate-500/30 bg-slate-500/10 text-slate-600',
  cancelado: 'border-red-500/30 bg-red-500/10 text-red-600',
  pospuesto: 'border-amber-500/30 bg-amber-500/10 text-amber-600'
};

export const ESTATUS_LABELS = {
  programado: 'Programado',
  en_curso: 'En Curso',
  terminado: 'Terminado',
  cancelado: 'Cancelado',
  pospuesto: 'Pospuesto'
};

export const RESULTADO_STYLES = {
  W: 'bg-green-100 text-green-700 border-green-300',
  L: 'bg-red-100 text-red-700 border-red-300',
  D: 'bg-gray-100 text-gray-700 border-gray-300'
};

export const RESULTADO_LABELS = { W: 'Victoria', L: 'Derrota', D: 'Empate' };
